import { render, staticRenderFns } from "./ModalClientChange.vue?vue&type=template&id=2a36f0ce&"
import script from "./ModalClientChange.vue?vue&type=script&lang=ts&"
export * from "./ModalClientChange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports